export default __webpack_public_path__ + "0a4f4122f29c8444fb3d95fc8fe69b73.png";